var newsletter = new function() {

    var me = this;

    this.bindEvents = function() {
        $("[data-form-newslettersubscribe]").bind("submit", function() {
            var form = $(this);
            var params = {
              'email': form.find("input[type='email']").val(),
              'lang': $('html').attr('lang'),
              '_token': window.Laravel.csrfToken
            };
            if($(this).valid()){
              $.post("/module/newsletter/subscribe",params, function(response) {
                  if(parseInt(response.code) == 1)
                    form.find("input[type='email']").val('');
                  $("[data-form-newslettermsg]").html( "<span class='newsletter__errorWrap'>" + response.msg + "</span>" );
              },"json");
            }
            return false;
        });
    };
}

$(document).ready(function() {
    newsletter.bindEvents();
});

$(document).ready(function () {
  var elements = document.querySelectorAll('.js-gallery');
  if(elements && elements.length>0){
    for(var i=0;i<elements.length;i++){
        $(".js-gallery").eq(i).magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Ładowanie #%curr%...',
            mainClass: 'mfp-with-zoom',
            tClose: 'Zamknij',
            removalDelay: 400,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                tPrev: 'Poprzednie',
                tNext: 'Następne',
                preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
                tCounter: '%curr% z %total%'
            },
            image: {
                tError: '<a href="%url%">Zdjęcie #%curr%</a> nie może być załadowane.',
                titleSrc: function (item) {
                    return item.el.attr('title');
                }
            }
        });
    }
  }






  // scrolledGallery for mobiles
  let scrolledGallery = function() {
      $('.js-scrolledGallery').slick({
          arrows: true,
          speed: 700,
          fade: true,
          autoplaySpeed: 7000,
          dots: true,
          infinite: true,
          autoplay: false,
          responsive: [
            {
              breakpoint: 1240,
              settings: {
                dots: false,
              }
            }
          ]
      });
  }
  if ($(window).width() < 800) {
      scrolledGallery();
  }
  $(window).on('resize', function(){
      if ($(window).width() < 800) {
          scrolledGallery();
      }
  });

});

$(document).ready(function(){
    var popupLink = $(".hiddenPopup");
    if(popupLink.length == 1){
      var type = popupLink.data("type");

      if(type!=null){
        type = type.replace(/\s*$/,"");

        if(type === "inline") {
            popupLink.magnificPopup({
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                items: {
                    src: '#popup',
                    type: type
                }
            });
        } else{
            popupLink.magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                iframe: {
                    markup: '<div class="mfp-iframe-scaler">' +
                    '<div class="mfp-close"></div>' +
                    '<iframe id="player" class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                    '</div>',
                    patterns: {
                        youtube: {
                            index: 'youtube.com/',
                            id: 'v=',
                            src: 'h%id%&autoplay=1'
                        }
                    }
                }
            });
        }
      }
    }
});

$(window).on('load',function () {
    $(".hiddenPopup").trigger("click");
});

$(document).ready(function () {
    var el = $('[data-cookies]');

    $('[data-closecookies]').on('click', function () {
        el.fadeOut();
        Cookies.set('cookies_info', '1', {expires: 12});
    });

    var myCookie = Cookies.get('cookies_info');
    if (myCookie === undefined) {
        el.show();
    }
});
$(document).ready(function () {
  $('.js-openMenu').on("click", function () {
    $(this).toggleClass('active');
    $('.mobileMenu').toggleClass('opened');
    $('body').addClass('noscroll');
  });

  $('.js-close').on("click", function () {
    $('.mobileMenu').removeClass('opened');
    $('body').removeClass('noscroll');
  });

  $('body').on("click", '.js-prev', function () {
    
    var el = $(this);
    $(".mobileMenu ul.opened").removeClass("opened");
    $("[data-menu].actived").removeClass("actived");
    $(".js-prev").remove();
  });

  $('.mobileMenu li').each(function() {
    if ( $(this).find('ul').length ) {
      $(this).addClass('withSubmenu');
      $(this).find('a').append('<span class="mobileMenu__submenuSwitcher"></span>');
    }
  });
  

  function submenuSwitcher() {
    $("[data-menu] .mobileMenu__submenuSwitcher").on("click", function (e) {
        if ($(e.target).hasClass('mobileMenu__submenuSwitcher')) {
          e.preventDefault();
          var el = $(this).parent();
          el.toggleClass("actived");
          el.next('ul').toggleClass("opened");
        }
    });
  }
  submenuSwitcher();

  $('.js-searchBox .searchBox__icon').on('click', function() {
    $(this).parent().toggleClass('active');
    $('.js-searchBox input').focus();
    $('.mobileMenu__language').toggleClass('hide');
  });

});

$(document).ready(function(){

  // wcag panel
    $('#wcagIcon').on('click', function() {
        $('#wcagPanel').toggleClass('opened')
    });

    $('.wcag__close').on('click', function() {
        $('#wcagPanel').removeClass('opened')
    });

  if(typeof sessionStorage["fontsize"] === "undefined")
    sessionStorage['fontsize'] = 0;

  var size = 0;
  $('.wcagFontsMinus').on("click", function () {
    if(size>-3 || size == 0){
      if ('sessionStorage' in window && typeof sessionStorage == 'object')
        sessionStorage["fontsize"] = parseInt(sessionStorage["fontsize"]) - 1;
      $('*').each(function(){
        $(this).css('font-size', parseInt($(this).css('font-size')) - 1);
      });
      size--;
    }
  });
  $('.wcagFontsPlus').on("click", function () {
    if(size<6){
      if ('sessionStorage' in window && typeof sessionStorage == 'object')
        sessionStorage["fontsize"] = parseInt(sessionStorage["fontsize"]) + 1;
      $('*').each(function(){
        $(this).css('font-size', parseInt($(this).css('font-size')) + 1);
      });
      size++;
    }
  });

  $('.wcagFontsReset').on("click", function () {
    sessionStorage['fontsize'] = 0;
    $('*').each(function(){
      $(this).css('font-size','');
    });
    size = 0;
  });

  $('.wcagFontsReads').on("click", function () {
      $('body').toggleClass('is_arial')
  });
  $('.wcagLinkUndeline').on("click", function () {
      $('body').toggleClass('is_underline')
  });
  $('.wcagLinkLighting').on("click", function () {
    $('body').toggleClass('is_lighting')
  });

  $('.wcagLinkReset ').on("click", function () {
    $('body').removeClass('is_lighting');
    $('body').removeClass('is_underline');
  });



  $('#wcagContrast-yellowBlack').on("click", function () {
    $('body').removeClass('blackYellow');
    $('body').removeClass('blackWhite');
    $('body').removeClass('whiteBlack');
    $('body').addClass('yellowBlack');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 0;
      sessionStorage["blackWhite"] = 0;
      sessionStorage["whiteBlack"] = 0;
      sessionStorage["yellowBlack"] = 1;
    }
  });


  $('#wcagContrast-blackYellow').on("click", function () {
    $('body').removeClass('yellowBlack');
    $('body').removeClass('blackWhite');
    $('body').removeClass('whiteBlack');
    $('body').addClass('blackYellow');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 1;
      sessionStorage["blackWhite"] = 0;
      sessionStorage["whiteBlack"] = 0;
      sessionStorage["yellowBlack"] = 0;
    }
  });


  $('#wcagContrast-blackWhite').on("click", function () {
    $('body').removeClass('yellowBlack');
    $('body').removeClass('whiteBlack');
    $('body').removeClass('blackYellow');
    $('body').addClass('blackWhite');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 0;
      sessionStorage["blackWhite"] = 1;
      sessionStorage["whiteBlack"] = 0;
      sessionStorage["yellowBlack"] = 0;
    }
  });

  $('#wcagContrast-whiteBlack').on("click", function () {
    $('body').removeClass('yellowBlack');
    $('body').removeClass('blackWhite');
    $('body').removeClass('blackYellow');
    $('body').addClass('whiteBlack');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 0;
      sessionStorage["blackWhite"] = 0;
      sessionStorage["whiteBlack"] = 1;
      sessionStorage["yellowBlack"] = 0;
    }
  });

  $('#wcagContrast-reset').on("click", function () {
    sessionStorage["blackYellow"] = 0;
    sessionStorage["blackWhite"] = 0;
    sessionStorage["whiteBlack"] = 0;
    sessionStorage["yellowBlack"] = 0;
    $('body').removeClass();
  });





    // Check if sessionStorage is supported
      if ('sessionStorage' in window && typeof sessionStorage == 'object') {
          if(parseInt(sessionStorage["fontsize"])!=0){
            var elements = $('*');
            var sizes = [];
            for(var i=0;i<elements.length;i++)
                sizes[i] = parseInt(elements.eq(i).css('font-size')) + parseInt(sessionStorage['fontsize']);
            for(var i=0;i<elements.length;i++)
              elements.eq(i).css('font-size', sizes[i]);
          }
          size = parseInt(sessionStorage['fontsize']);

          ["blackYellow","blackWhite","whiteBlack","yellowBlack"].forEach(function(element){
            if(parseInt(sessionStorage[element])==1){
              $('body').removeClass();
              $('#wcagContrast-'+element).trigger('click');
            }
          });
      }

      });

// main slider
var nextSlide = window.Laravel.lang.slider.next;
var prevSlide = window.Laravel.lang.slider.prev;

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.swiper-workin', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: '-25',
    centeredSlides: true,
    slideToClickedSlide: true,
    pagination: {
      el: '.swiper-workin .swiper-pagination',
      clickable: true
    },

    navigation: {
      nextEl: '.swiper-workin-next',
      prevEl: '.swiper-workin-prev'
    },

    breakpoints: {
      992: {
        slidesPerView: 3
      }
    }
  });

  if ( $(".swiper-workin").length ) {
    const $workinSwiper = $(".swiper-workin");

    $workinSwiper.on('click', 'a', function (e) {
      const $slide = $(this).closest('.swiper-slide');
      if (!$slide.hasClass('swiper-slide-active')) {
        e.preventDefault();
        e.stopPropagation();

        const realIndexAttr = $slide.attr('data-swiper-slide-index');
        const realIndex = realIndexAttr != null ? parseInt(realIndexAttr, 10) : null;
        if (realIndex != null && !Number.isNaN(realIndex)) {
          swiper.slideToLoop(realIndex);
        }
      }
    });

    $workinSwiper.magnificPopup({
      delegate: 'a',
      type: 'image',
      mainClass: 'mfp-with-zoom',
      removalDelay: 400,
      gallery: {
        enabled: true
      }
    });
  }

  const testimonialsEl = document.querySelector('.homeTestimonials__slider.swiper');
  if (testimonialsEl) {
    const testimonialsList = testimonialsEl.querySelector('.homeTestimonials__list');
    const testimonialsMq = window.matchMedia('(max-width: 767px)');
    let testimonialsSwiper = null;

    function syncTestimonialsSwiper() {
      if (testimonialsMq.matches && !testimonialsSwiper) {
        testimonialsList.classList.add('swiper-wrapper');
        testimonialsSwiper = new Swiper(testimonialsEl, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 24,
          pagination: {
            el: testimonialsEl.querySelector('.swiper-pagination'),
            clickable: true
          }
        });
      } else if (!testimonialsMq.matches && testimonialsSwiper) {
        testimonialsSwiper.destroy(true, true);
        testimonialsSwiper = null;
        testimonialsList.classList.remove('swiper-wrapper');
      }
    }

    syncTestimonialsSwiper();
    testimonialsMq.addEventListener('change', syncTestimonialsSwiper);
  }
});


// imageslider
var elements = document.querySelectorAll('.js-sliderGallery');
if (elements.length > 0) {
  $('.js-sliderGallery').slick({
    arrows: true,
    speed: 700,
    autoplaySpeed: 7000,
    dots: true,
    infinite: true,
    autoplay: true,
    slidesPerRow: 5,
    rows: 2,
    responsive: [
      {
        breakpoint: 678,
        settings: {
          slidesPerRow: 2,
          rows: 2,
        }
      }
    ]
  });
}


//logoSlider
if ($('.js-logoSlider').length) {
  $('.js-logoSlider').slick({
    arrows: true,
    speed: 700,
    autoplaySpeed: 7000,
    dots: true,
    infinite: true,
    autoplay: false,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 900,
        adaptiveHeight: false,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
      ,
      {
        breakpoint: 600,
        adaptiveHeight: true,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
//productSlider
if ($('.js-productSlider').length) {
  $('.js-productSlider').slick({
    speed: 700,
    fade: true,
    autoplaySpeed: 7000,
    dots: true,
    infinite: true,
    autoplay: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1240,
        settings: {
          dots: false
        }
      }
    ]
  });
}

function setTimeSlider() {
  let sliderOpac = $('.slider');
  sliderOpac.addClass('sliderShow');
}

setTimeout(setTimeSlider, 100);

//testimonials
if ($('.homeTestimonials__slider').length) {
  // $('.homeTestimonials__slider').slick({
  //   speed: 700,
  //   fade: true,
  //   autoplaySpeed: 7000,
  //   dots: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   infinite: true,
  //   autoplay: false,
  //   arrows: true,
  //   responsive: [
  //     {
  //       breakpoint: 1240,
  //       settings: {
  //         dots: false
  //       }
  //     }
  //   ]
  // });
}

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webp-setclasses !*/
 !function(e,n,A){function o(e,n){return typeof e===n}function t(){var e,n,A,t,a,i,l;for(var f in r)if(r.hasOwnProperty(f)){if(e=[],n=r[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(A=0;A<n.options.aliases.length;A++)e.push(n.options.aliases[A].toLowerCase());for(t=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],l=i.split("."),1===l.length?Modernizr[l[0]]=t:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=t),s.push((t?"":"no-")+l.join("-"))}}function a(e){var n=u.className,A=Modernizr._config.classPrefix||"";if(c&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+A+"no-js(\\s|$)");n=n.replace(o,"$1"+A+"js$2")}Modernizr._config.enableClasses&&(n+=" "+A+e.join(" "+A),c?u.className.baseVal=n:u.className=n)}function i(e,n){if("object"==typeof e)for(var A in e)f(e,A)&&i(A,e[A]);else{e=e.toLowerCase();var o=e.split("."),t=Modernizr[o[0]];if(2==o.length&&(t=t[o[1]]),"undefined"!=typeof t)return Modernizr;n="function"==typeof n?n():n,1==o.length?Modernizr[o[0]]=n:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=n),a([(n&&0!=n?"":"no-")+o.join("-")]),Modernizr._trigger(e,n)}return Modernizr}var s=[],r=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var A=this;setTimeout(function(){n(A[e])},0)},addTest:function(e,n,A){r.push({name:e,fn:n,options:A})},addAsyncTest:function(e){r.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var f,u=n.documentElement,c="svg"===u.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;f=o(e,"undefined")||o(e.call,"undefined")?function(e,n){return n in e&&o(e.constructor.prototype[n],"undefined")}:function(n,A){return e.call(n,A)}}(),l._l={},l.on=function(e,n){this._l[e]||(this._l[e]=[]),this._l[e].push(n),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},l._trigger=function(e,n){if(this._l[e]){var A=this._l[e];setTimeout(function(){var e,o;for(e=0;e<A.length;e++)(o=A[e])(n)},0),delete this._l[e]}},Modernizr._q.push(function(){l.addTest=i}),Modernizr.addAsyncTest(function(){function e(e,n,A){function o(n){var o=n&&"load"===n.type?1==t.width:!1,a="webp"===e;i(e,a&&o?new Boolean(o):o),A&&A(n)}var t=new Image;t.onerror=o,t.onload=o,t.src=n}var n=[{uri:"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",name:"webp"},{uri:"data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",name:"webp.alpha"},{uri:"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",name:"webp.animation"},{uri:"data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",name:"webp.lossless"}],A=n.shift();e(A.name,A.uri,function(A){if(A&&"load"===A.type)for(var o=0;o<n.length;o++)e(n[o].name,n[o].uri)})}),t(),a(s),delete l.addTest,delete l.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();e.Modernizr=Modernizr}(window,document);
var ALL_PRODUCTS_MENU_CLOSE_OTHERS = false;

$(document).on('click', '.all-products-menu__category-label.has-children', function (e) {
  e.preventDefault();
  e.stopPropagation();

  var $label = $(this);
  var $item = $label.closest('.all-products-menu__category-item.level-1');
  var $submenu = $item.children('.all-products-menu__category-menu.level-2');

  if ($submenu.length === 0) {
    return;
  }

  if (ALL_PRODUCTS_MENU_CLOSE_OTHERS) {
    $item
      .siblings('.all-products-menu__category-item.level-1')
      .each(function () {
        $(this)
          .children('.all-products-menu__category-menu.level-2:visible')
          .stop(true, true)
          .slideUp(200, function () {
            $(this).removeAttr('style');
          });

        $(this)
          .children('.all-products-menu__category-label.has-children')
          .removeClass('is-open');
      });
  }

  if ($submenu.is(':visible')) {
    $submenu.stop(true, true).slideUp(200, function () {
      $(this).removeAttr('style');
    });
    $label.removeClass('is-open');
  } else {
    $submenu
      .stop(true, true)
      .css('display', 'flex')
      .hide()
      .slideDown(200, function () {
        $(this).css('display', 'flex');
      });
    $label.addClass('is-open');
  }
});

$(document).ready(function(){

  let question = document.querySelectorAll(".question");

  question.forEach(question => {
    question.addEventListener("click", event => {
      const active = document.querySelector(".question.active");
      if(active && active !== question ) {
        active.classList.toggle("active");
        active.nextElementSibling.style.maxHeight = 0;
      }
      question.classList.toggle("active");
      const answer = question.nextElementSibling;
      if(question.classList.contains("active")){
        answer.style.maxHeight = answer.scrollHeight + "px";
      } else {
        answer.style.maxHeight = 0;
      }
    })
  })


  //language - select
  if ($('.languageBox__select').length) {
    $('.languageBox__select').on('click', function() {
        $('.languageBox__list').toggleClass('visible');
        $(this).toggleClass('open');
        return false;
    });
  }

  $('.header__login-withSubmenu').on('click', function(){
      $('.header__login-submenu').slideToggle(300);
  });

  $('.myAcc').on('click', function(){
      event.preventDefault();
  });



  //aos
  if ( $('[data-aos]').length ) {
      AOS.init({
          offset: 50,
          duration: 500
      });
  }

  // lazy loads elements with default selector as '.lozad'
  if ($('.lozad').length) {
    const observer = lozad();
    observer.observe();
  }

  // Handle Lazy loading on page print
  window.onbeforeprint = function() {
    $('.lozad').each(function() {
      var src = $(this).attr('data-src');
      $(this).attr('src', src).parent().addClass('loaded');
    });
  };


  // relax init
  if ($('.rellax').length) {
      var rellax = new Rellax('.rellax', {
        wrapper: '.rellax-parent',
        relativeToWrapper: true,
      });
  }

  // js-up
  $(".js-up").on("click", function () {
      var body = $("html, body");
      body.stop().animate({scrollTop: 0}, 1500, 'swing');
  });

  //search
  $('.js-header__search').on('click', function(){
      $('.header .searchBox').slideToggle(300);
  });
  $('.header .searchBox .searchBox__close').on('click', function(){
      $('.header .searchBox').slideToggle(300);
  });

  $('.searchBoxIcon').on('click', function(){
    $('[data-search-form]').submit();
  });

  // job offers filtering
  if ($('.job-offers__filters-btn').length) {
    function filterJobOffers() {
      var title = $('#jof_job_title').val().toLowerCase().trim();
      var place = $('#jof_workplace').val().toLowerCase().trim();
      var count = 0;
      $('.job-offers__list tbody tr').each(function() {
        var rowTitle = $(this).find('td[data-label="Stanowisko"]').text().toLowerCase();
        var rowPlace = $(this).find('td[data-label="Miejsce pracy"]').text().toLowerCase();
        var match = rowTitle.includes(title) && rowPlace.includes(place);
        $(this).toggle(match);
        if (match) count++;
      });
      $('.job-offers__list').toggle(count > 0);
      $('.job-offers__empty').toggle(count === 0);
    }
    $('.job-offers__filters-btn').on('click', filterJobOffers);
    $('#jof_job_title, #jof_workplace').on('keydown', function(e) {
      if (e.key === 'Enter') filterJobOffers();
    });
  }

}); // end document ready

$(window).on("scroll", function () {

// js-up
var scroll = $(window).scrollTop();
if (scroll > 600) {
    $(".js-up").addClass("visible");
} else {
    $(".js-up").removeClass("visible");
}

// scrolled menu
if ($(window).scrollTop() > 0){
  $('.js-header').addClass('header--scrolled');
 }else {
     $(".js-header").removeClass("header--scrolled");
 }

}); // end onscroll

//# sourceMappingURL=front.js.map
